import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

const exportCountReportList = createSlice({
  name: "exportCountReportList",
  initialState,
  reducers: {
    addCountReportList: (state, action) => {
      state.data = action.payload;
    },
    updateTableRow: (state, action) => {
      const updatedRow = action.payload;
      const index = state.tableData.data.findIndex(
        (data) => data?.id === updatedRow?.id
      );
      state.tableData.data[index] = updatedRow;
    },
  },
});

export const { addCountReportList,updateTableRow } = exportCountReportList.actions;
export default exportCountReportList.reducer;
